import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import { buildModuleHandoffUrl } from "@itaas/core/modules";
import { resolvePepWebBase } from "@itaas/core/marketing";
import { useAuth } from "@itaas/core/auth/useAuth";
import { canAccessPlatformCommercial } from "@/navigation/platform-access";
import { routes } from "@/router/all_routes";

const PEP_URL = resolvePepWebBase();

export function PlatformCommercialPage() {
  const { user } = useAuth();

  useEffect(() => {
    if (!canAccessPlatformCommercial(user)) return;
    const session = loadStoredSession();
    if (!session) return;

    const url = buildModuleHandoffUrl(
      PEP_URL,
      "/admin/handoff",
      session,
      "/admin/leads",
    );
    window.location.assign(url);
  }, [user]);

  if (!canAccessPlatformCommercial(user)) {
    return <Navigate to={routes.accessDenied} replace />;
  }

  return (
    <div className="suite-platform-page">
      <header className="suite-platform-page__header">
        <div>
          <h1 className="h4 mb-1">Commercial</h1>
          <p className="text-muted small mb-0">Administration PEP — devis, démos et essais</p>
        </div>
      </header>

      <div className="text-center py-5">
        <div className="spinner-border text-primary mb-3" />
        <p className="text-muted mb-3">Redirection vers l&apos;administration commerciale PEP…</p>
        <a className="btn btn-primary btn-sm" href={PEP_URL}>
          Ouvrir PEP manuellement
        </a>
      </div>
    </div>
  );
}
